import {_utils, observers} from "./utils/_utils.js";
import {_libs} from "./utils/_libs.js";
import {_state, getLocalState} from "./state/state.js";
import {setupHeader} from "./components/header/setup-header.js";
import {hpHero} from "./components/hero/hp-hero.js";
import {pageHero} from "./components/hero/page-hero.js";
import {galleryHero} from "./components/hero/gallery-hero.js";
import {hpJourney} from "./components/home/hp-journey.js";
import {hpGallery} from "./components/home/hp-gallery.js";
import {hpIcon} from "./components/home/hp-icon.js";
import {hpSteps} from "./components/home/hp-steps.js";
import {ctaBanner} from "./components/other/cta-banner.js";
import {testimonials} from "./components/other/testimonials.js";
import {abHistory} from "./components/about/ab-history.js";
import {abStats} from "./components/about/ab-stats.js";
import {abHospitality} from "./components/about/ab-hospitality.js";
import {abTeam} from "./components/about/ab-team.js";
import {abMilestones} from "./components/about/ab-milestones.js";
import {scrollTabs} from "./components/other/scroll-tabs.js";
import {faq} from "./components/other/faq.js";
import {logoStrip} from "./components/other/logo-strip.js";
import {cardsCarousel} from "./components/other/cards-carousel.js";
import {clickTabs} from "./components/other/click-tabs.js";
import {mediaText} from "./components/other/media-text.js";
import {gallerySlider} from "./components/other/gallery-slider.js";
import {stackSlides} from "./components/other/stack-slides.js";
import {legalContent} from "./components/other/legal-content.js";
import {feedbackForm} from "./components/other/feedback-form.js";
import {autoTabs} from "./components/other/auto-tabs.js";

document.addEventListener('DOMContentLoaded', async (event) => {
    await Promise.all([
        _libs._lazyLoad(),
        getLocalState(),
        _libs._OverlayScrollbars(),
    ]);

    let isUserInteracted = true;
    _state.interactionEvents.forEach(event => {
        window.addEventListener(event, async () => {
            if (isUserInteracted) {
                isUserInteracted = false;
                await Promise.all([
                    _utils.initOnUserInteraction(),
                    _libs.initOnUserInteraction(),
                ])
                _state.updateState({isUserActive: true});
            }
        });
    });

    await Promise.all([
        _utils.init(),
        _libs.init(),
        observers.init(),

        setupHeader(),
        hpHero(),
        pageHero(),
        galleryHero(),
        hpJourney(),
        hpGallery(),
        hpIcon(),
        hpSteps(),
        ctaBanner(),
        testimonials(),
        abHistory(),
        abStats(),
        abHospitality(),
        abTeam(),
        abMilestones(),
        scrollTabs(),
        faq(),
        logoStrip(),
        cardsCarousel(),
        clickTabs(),
        mediaText(),
        gallerySlider(),
        stackSlides(),
        legalContent(),
        feedbackForm(),
        autoTabs(),
    ]).then(async () => {
        await Promise.all([
            _utils.anchorInUrl(),
        ])

        // start AOS (data-aos="focus-in") once the layout is final
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                document.dispatchEvent(new Event('aos:ready'));
            });
        });
    });
});